<template>
  <div v-if="isPickTopicActiveLocal">
    <div class="vx-row ml-1">
      <div class="vx-col">
        <vx-card card-background="transparent" class="remove-shadow card__no-padding" style="width: 277px">
          <vx-input-group>
            <vs-button
              :disabled="true"
              size="large"
              style="color:white;"
              class="button__fully-opaque button-text__left-align remove-shadow header_button-lookalike"
              type="filled"
              color="">
              You have selected:
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>
    <div class="ml-0">
      <div class="vx-row">
        <div class="vx-col w-full sm:w-full xs:w-full md:w-full lg:w-1/4">
          <vx-card card-background="transparent" class="mb-4 glow-effect_dark card__no-padding">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_dark input-group_prepend-slot-bg">
                  <span><feather-icon class="pt-1" icon="MessageCircleIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                size="large"
                class="w-full button-text__left-align glow-effect_primary__hover back-button"
                style="border-radius:0 7px 7px 0"
                type="filled"
                color="#262d4a"
                @click="backToPickLanguage">
                <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
                {{ selectedLanguage }}
              </vs-button>
            </vx-input-group>
          </vx-card>
        </div>
        <div class="vx-col w-full sm:w-full xs:w-full md:w-full lg:w-1/4">
          <vx-card card-background="transparent" class="mb-4 glow-effect_dark card__no-padding">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_dark input-group_prepend-slot-bg">
                  <span><feather-icon class="pt-1" icon="BookmarkIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                size="large"
                class="w-full button-text__left-align glow-effect_primary__hover back-button"
                style="border-radius:0 7px 7px 0"
                type="filled"
                color="#262d4a"
                @click="backToPickGrade">
                <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
                {{ selectedGrade.name }}
              </vs-button>
            </vx-input-group>
          </vx-card>
        </div>
        <div class="vx-col w-full sm:w-full xs:w-full md:w-full lg:w-1/4">
          <vx-card card-background="transparent" class="mb-4 glow-effect_dark card__no-padding">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_dark input-group_prepend-slot-bg">
                  <img height="25" :src="selectedSubject.icon" />
                </div>
              </template>

              <vs-button
                size="large"
                class="w-full button-text__left-align glow-effect_primary__hover back-button"
                style="border-radius:0 7px 7px 0"
                type="filled"
                color="#262d4a"
                @click="backToPickSubject">
                <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
                {{ selectedSubject.name }}
              </vs-button>
            </vx-input-group>
          </vx-card>
        </div>
        <div class="vx-col w-full sm:w-full xs:w-full md:w-full lg:w-1/4">
          <vx-card card-background="transparent" class="mb-4 glow-effect_dark card__no-padding">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_dark input-group_prepend-slot-bg">
                  <span><feather-icon class="pt-1" icon="CodesandboxIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                size="large"
                class="w-full button-text__left-align glow-effect_primary__hover back-button"
                style="border-radius:0 7px 7px 0"
                type="filled"
                color="#262d4a"
                @click="backToPickModule">
                <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
                {{ selectedModule.name }}
              </vs-button>
            </vx-input-group>
          </vx-card>
        </div>
      </div>
    </div>
    <div class="vx-row mt-3">
      <div class="vx-col">
        <vx-card card-background="transparent" class="remove-shadow card__no-padding" style="width: 277px">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text remove-shadow" style="background-color: transparent">
                <span><feather-icon class="pt-2" icon="DiscIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button
              :disabled="true"
              size="large"
              class="button__fully-opaque button-text__left-align remove-shadow header_button-lookalike text__school-font-color"
              type="filled"
              color="">
              Select a Topic
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>
    <div class="ml-4">
      <div class="vx-row mr-0" v-for="(_term, index) in terms" :key="index">
        <vx-card card-background="transparent" class="mb-4 remove-shadow card__no-padding">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text remove-shadow grade-symbol" style="background-color: transparent">
                <span><feather-icon class="pt-2" icon="ClockIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button
              :disabled="true"
              size="large"
              class="w-full button__fully-opaque button-text__left-align remove-shadow"
              style="border-radius:0 7px 7px 0;"
              type="filled"
              color="">
              {{ _term.name }}
            </vs-button>
          </vx-input-group>
        </vx-card>

        <div class="w-full mb-3" v-for="(_topic, topicIndex) in topics.filter(function(item){return item.termId == _term.id})" :key="topicIndex">
          <vx-card class="mb-4 glow-effect_dark card__no-padding bg-color">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_dark grade-symbol input-group_prepend-slot-bg">
                  <span><feather-icon class="pt-2" icon="DiscIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                size="large"
                class="w-full button__fully-opaque button-text__left-align glow-effect_primary school-primary_gradient"
                style="border-radius:0 7px 7px 0;"
                @click="selectTopic(_topic)">
                {{ _topic.name }}
              </vs-button>
            </vx-input-group>
          </vx-card>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col mx-auto">
          <p v-if="showComingSoon" style="color:white;font-weight:500;font-size:16px;padding-top:5px">There are currently no topics for {{ selectedModule.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isPickTopicActive: {
      type: Boolean,
      required: true
    },
    selectedLanguage: {
      type: String,
      required: false
    },
    selectedGrade: {
      required: false
    },
    selectedSubject: {
      required: false
    },
    selectedModule: {
      required: false
    },
    moduleData: {
      required: false
    }
  },
  data() {
    return {
      terms: [],
      topics: [],
      showComingSoon: false
    };
  },
  computed: {
    isPickTopicActiveLocal: {
      get() {
        return this.isPickTopicActive;
      }
    }
  },
  watch: {
    isPickTopicActiveLocal: function(val) {
      if(val) {
        var self = this;
        if(self.moduleData)
          self.getTermsAndTopics();
      }
    }
  },
  methods: {
    initValues() {
      this.terms = [];
      this.topics = [];
    },
    getTermsAndTopics() {
      var self = this;
      self.showComingSoon = false;

      self.initValues();

      var temp_terms = [];

      temp_terms = self.moduleData.map(function(item) {
        return { id: item.moduleGroupId, name: item.moduleGroupName };
      });

      self.topics = self.moduleData.map(function(item) {
        return {
          id: item.id,
          name: item.name,
          moduleId: item.moduleCategoryId,
          termId: item.moduleGroupId,
          startTaskDisplayId: item.startTaskDisplayId,
          hasNewContent: item.hasNewContent
        };
      }).filter(function(item){ return item.moduleId == self.selectedModule.id });

      temp_terms.filter(function(item) {
        return self.topics.map(function(_topic) {
          return _topic.termId; 
        }).includes(item.id);
      }).forEach(_term => {
        if (self.terms.filter(function(item) {
          return _term.id == item.id
        }).length == 0 && _term.id != null)
          self.terms.push(_term);
      });

      self.terms = self.terms.sort(function (a, b) { return a.name > b.name ? 1 : -1; });

      self.showComingSoon = self.topics.length == 0 ? true : false;
    },
    selectTopic(topic) {
      this.$emit("topicSelected", topic);
    },
    backToPickLanguage() {
      this.initValues();
      this.$emit("backToPickLanguage");
    },
    backToPickGrade() {
      this.initValues();
      this.$emit("backToPickGrade");
    },
    backToPickSubject() {
      this.initValues();
      this.$emit("backToPickSubject");
    },
    backToPickModule() {
      this.initValues();
      this.$emit("backToPickModule");
    },
  },
  mounted() {
    
  }
};
</script>